<template>
  <div>
    <sale-order-list v-show="activeKey===1" ref="list" :orderStatus="orderStatus" :storers="storers" @add="add" @getDetail="getDetail"/>
    <sale-order-detail v-show="activeKey===2" ref="detail" :storers="storers" @back="back"/>
  </div>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import SaleOrderList from '@/views/outbound/sale_order_make/SaleOrderList.vue'
import SaleOrderDetail from '@/views/outbound/sale_order_make/SaleOrderDetail.vue'

export default {
  name: 'SaleOrderMake',
  components: { SaleOrderList, SaleOrderDetail },
  data() {
    return {
      activeKey: 1,
      orderStatus: [],
      storers: []
    }
  },
  created() {
    findEnum('OrderStatus').then(res => {
      if (res.success) {
        this.orderStatus = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    findAll('storerFactory', { available: true }).then(res => {
      if (res.success) {
        this.storers = res.result.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    getDetail(row) {
      this.activeKey = 2
      this.$refs.detail.fetch(row)
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.reset()
    }
  }
}
</script>